import { HttpHandler } from 'msw'

import { createPriceTable } from './createPriceTable'
import { deletePriceTable } from './deletePriceTable'
import { getAllPriceTables } from './getAllPriceTables'
import { getPriceTable } from './getPriceTable'
import { updatePriceTable } from './updatePriceTable'

export const priceTables: HttpHandler[] = [
    createPriceTable,
    deletePriceTable,
    getAllPriceTables,
    getPriceTable,
    updatePriceTable,
]
